<template>
  <div :id="id" class="chart-line"></div>
</template>

<script>
import Highcharts from 'highcharts';
// import { formatDataTime } from '~/utils/util';
export default {
  name: 'ChartLine',
  data () {
    return {
    };
  },
  props: {
    info: {
      type: Array,
      default () {
        return [2, 3, 5, 3, 4, 2, 4];
      }
      // required: true
    },
    color: {
      type: String,
      default: '#14C393'
    },
    id: {
      type: String,
      required: true
    }
  },
  created () {

  },
  mounted () {
    this.init();
  },
  watch: {
    info (curVal) {
      this.init();
    },
    color (val) {
      this.init();
    }
  },
  methods: {
    async init () {
      const xData = this.info.map((item, index) => {
        return index + 1;
      });
      const yData = this.info.map(item => {
        return item;
      });
      Highcharts.chart(this.id, {
        chart: {
          type: 'spline',
          margin: 0
        },
        title: {
          text: ''
        },
        tooltip: {
          enabled: false
        },
        // subtitle: {
        //   text: 'Source: thesolarfoundation.com'
        // },
        colors: [this.color],
        xAxis: {
          visible: false,
          // tickInterval: 3, // 坐标显示间隔
          title: {
            text: 'Time',
            enabled: false
          },
          categories: xData
          // labels: {
          //   formatter: function () {
          //     return this.value.slice(5, 10);
          //   }
          // }
        },
        yAxis: {
          visible: false,
          title: {
            text: 'Funding Rate',
            enabled: false
          }
        },
        spline: { // 线条样式
          lineWidth: 3,
          linecap: 'round'
        },
        credits: {
          enabled: false
        },
        legend: {
          enabled: false
        },
        plotOptions: {
          spline: {
            allowPointSelect: false,
            marker: {
              enabled: false,
              states: {
                hover: {
                  enabled: false // 隐藏数据点
                }
              }
            }
          }
        },
        series: [{
          name: this.$t('funding_7'),
          data: yData,
          accessibility: {
            enabled: false
          }
        }]

        // responsive: {
        //   rules: [{
        //     condition: {
        //       maxWidth: 500
        //     }
        //   }]
        // }

      });
    }
  }
};
</script>

<style lang="scss" scoped>

.chart-line {
  width: 60px;
  height: 25px;
}

</style>
